import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LcsResponsiveTableModule, LcsTableModule } from '@lcs/shared/table';
import { PagedTableWrapperModule } from '@ndt/report-output/shared/paged-table-wrapper/paged-table-wrapper.module';
import { FormatMinutesPipeModule } from 'src/app/pipes/format-minutes/format-minutes-pipe.module';
import { TilesModule } from '../../tiles.module';
import { SharedTileModule } from '../shared/shared-tile.module';
import { PhoneQueuesTileComponent } from './phone-queues-tile.component';

@NgModule({
   declarations: [PhoneQueuesTileComponent],
   imports: [
      CommonModule,
      TilesModule,
      SharedTileModule,
      LcsResponsiveTableModule,
      ScrollingModule,
      RouterModule,
      PagedTableWrapperModule,
      LcsTableModule,
      FormatMinutesPipeModule,
   ],
   exports: [PhoneQueuesTileComponent],
})
export class PhoneQueuesTileModule {}
